import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import bgImage from "assets/backgrounds/authBackground.webp";
import Logo from "components/Logo";
import { useMediaQueries } from "shared/hooks/useMediaQueries";
import { body1SemiBoldStyles, headline4Styles } from "shared/styles/typography";

import LanguageSelection from "../shared/LanguageSelection";
import { AuthContainerProps } from "../types";
import Contacts from "./Contacts";

const AuthContainer = ({
    children,
    formName,
    secondaryText,
    topButton
}: AuthContainerProps) => {
    const { blue100 } = colors;

    const { fromMd } = useMediaQueries();

    return (
        <section className="remaining-height">
            <div
                css={css({
                    flex: "1",
                    display: "grid",
                    gridTemplateColumns: "repeat(12, 1fr) 24px",

                    "@media (max-width:1439px)": {
                        gridTemplateColumns: "24px repeat(12, 1fr)"
                    },

                    "@media (max-width:839px)": {
                        gridTemplateColumns: "1fr"
                    }
                })}
            >
                <div
                    css={css({
                        display: "flex",
                        flexDirection: "column",
                        gridColumn: "1 / span 5",

                        "@media (max-width:1439px)": {
                            gridColumn: "1 / span 6"
                        }
                    })}
                >
                    <div
                        css={css({
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            columnGap: "16px",
                            overflowX: "hidden",
                            padding: "10px 24px",

                            "@media (max-width:599px)": {
                                padding: "10px 16px"
                            }
                        })}
                    >
                        <Logo css={{ flexShrink: "0" }} />
                        <LanguageSelection />
                    </div>

                    <div
                        css={css({
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "1",
                            padding: "0 112px",

                            "@media (max-width:1439px)": {
                                padding: "0 24px"
                            },

                            "@media (max-width:599px)": {
                                padding: "0 16px"
                            }
                        })}
                    >
                        <div
                            css={css({
                                maxWidth: "500px"
                            })}
                        >
                            {topButton}

                            <div
                                css={css({
                                    marginBottom: "24px",

                                    h1: {
                                        ...headline4Styles,
                                        whiteSpace: "pre-line"
                                    },

                                    h3: {
                                        ...body1SemiBoldStyles,
                                        marginTop: "8px"
                                    }
                                })}
                            >
                                <h1>{formName}</h1>
                                <h3>{secondaryText}</h3>
                            </div>

                            <div>{children}</div>

                            <Contacts />
                        </div>
                    </div>
                </div>

                {fromMd && (
                    <div
                        css={css({
                            gridColumn: "6 / -1",
                            backgroundImage: `url(${bgImage})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundColor: blue100,

                            "@media (max-width:1439px)": {
                                gridColumn: "7 / -1"
                            }
                        })}
                    />
                )}
            </div>
        </section>
    );
};

export default AuthContainer;
